import type { PropsWithChildren } from 'react';
import { createContext } from 'react';

import type { ProductSearchCriteria } from '@jane/bloom/viewModels/productSearch';
import type {
  FilterTypeKeysWithJaneGold,
  ProductSearchFiltersViewModel,
} from '@jane/bloom/viewModels/productSearchFilters';
import { buildFilterKeysToDisplay } from '@jane/bloom/viewModels/productSearchFilters';

type BloomFilterContext = {
  availableFilters?: ProductSearchFiltersViewModel;
  displayFilterKeys: FilterTypeKeysWithJaneGold[];
  searchCriteria?: ProductSearchCriteria;
};

export const BloomFilterContext = createContext<BloomFilterContext>({
  displayFilterKeys: [],
});

export function BloomFilterProvider({
  availableFilters,
  children,
  displayFilterKeys = buildFilterKeysToDisplay(),
  searchCriteria,
}: PropsWithChildren<Partial<BloomFilterContext>>) {
  return (
    <BloomFilterContext.Provider
      value={{
        availableFilters,
        displayFilterKeys,
        searchCriteria,
      }}
    >
      {children}
    </BloomFilterContext.Provider>
  );
}
